import { CustomDialog } from '@/components/dialogs/custom-dialog'

export function ImagePreview({ isOpen, url, onClose }: { isOpen: boolean; url: string; onClose: () => void }) {
  return (
    <CustomDialog open={isOpen} persistent={false} title="Visualizar arquivo" confirmationBeforeClose={false} onClose={() => onClose()} className="min-w-[1200px]">
      <div className="flex flex-col items-center justify-center">
        <img src={url} alt={url} className="w-auto max-w-[1100px] h-auto max-h-[700px] object-fit" />
      </div>
    </CustomDialog>
  )
}
